export const mapApiResponseToForm = (apiResponse = {}) => ({
  design: {
    background: {
      bgColor: apiResponse?.bg_color,
      bgImage: {
        editedImage: apiResponse?.bg_image_url,
      },
    },
    tile: {
      bgColor: apiResponse?.tile_bg_color,
      font: apiResponse?.font_family,
      fontColor: apiResponse?.font_color,
    },
    icon: {
      bubbleColor: apiResponse?.button_color,
      iconColor: apiResponse?.white_icons ? "1" : "2",
    },
  },
  add_contacts: {
    removeSearch: apiResponse?.remove_search,
    contacts: apiResponse?.users,
  },
})

export const customTextField = ({
  input,
  type = "text",
  meta: { touched, error, submitFailed },
}) => {
  return (
    <div>
      <input
        type={type}
        className="form-control"
        {...input}
        style={{
          background: "transparent",
          borderWidth: "0px 0px 1px",
          borderColor: "rgba(0,0,0,0.12)",
          outline: "none",
          borderRadius: "0px",
        }}
      />
      {error && <span className={"input-error"}>{error}</span>}
    </div>
  )
}

export const disableSaveButton = (
  name,
  email,
  emailCheckbox,
  phone,
  phoneCheckbox
) => {
  if (!name) {
    return true
  }
  if (emailCheckbox && (!email || email?.trim()?.length === 0)) {
    return true
  }
  if (phoneCheckbox && (!phone || phone?.trim()?.length === 0)) {
    return true
  }
  return false
}

export const mapFormToApi = (formValues = {}) => ({
  bg_color: formValues?.design?.background?.bgColor,
  bg_image_url: formValues?.design?.background?.bgImage?.editedImage,
  button_color: formValues?.design?.icon?.bubbleColor,
  font_color: formValues?.design?.tile?.fontColor,
  font_family: formValues?.design?.tile?.font,
  tile_bg_color: formValues?.design?.tile?.bgColor,
  white_icons: formValues?.design?.icon?.iconColor === "1" ? true : false,
  users: formValues?.add_contacts?.contacts,
  user_ids: formValues?.add_contacts?.contacts?.map(contact => contact?.id),
  remove_search: formValues?.add_contacts?.removeSearch,
  ...(formValues?.design?.background?.deleteBgImage &&
  !formValues?.design?.background?.bgImage?.editedImage
    ? { delete_bg_image: 1 }
    : {}),
})
